import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Box, Button, TooltipLink, Typography } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { type AircallNumbersListStore } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationAircallSettings/store/AircallNumbersListStore'

type IAircallBulkActionsProps = {
  store: AircallNumbersListStore
}

export const BulkActions: FC<IAircallBulkActionsProps> = observer(({ store }) => {
  const assignText = store.tableStore.selectedIds.length > 1 ? 'Assign numbers' : 'Assign number'

  const handleAssignNumbers = () => {
    store.assignNumbers(store.tableStore.selectedIds)
  }

  return (
    <Button
      text={assignText}
      size='small'
      contained='tertiary'
      onClick={handleAssignNumbers}
      disabled={store.tableStore.selectedIds.length === 0 || store.isNumbersGracePeriod}
      tooltipProps={
        store.isNumbersGracePeriod
          ? {
              type: 'description',
              label: (
                <Box display='flex' flexDirection='column' gap={0.5}>
                  <Typography
                    variant={'body-md-regular'}
                    color={'var(--content-primary-primary-inverted)'}
                    ariaLabel={'Grace Period'}
                  >
                    Take care of unpaid licenses
                    <br /> before adding new numbers.
                  </Typography>
                </Box>
              ),
              width: 233,
              placement: 'top',
              desc: (
                <TooltipLink
                  text='Manage numbers'
                  onClick={() => {
                    uiStore.changeRoute({
                      path: '/settings/organization/numbers',
                    })
                  }}
                />
              ),
            }
          : undefined
      }
    />
  )
})
